export type MechaNFTOrderType = 'Recently acquired';

export const MechaNFTOrder: {
  [key: string]: MechaNFTOrderType;
} = {
  MOST_RECENT: 'Recently acquired',
};

export const MECHA_DEFAULT_SORT = MechaNFTOrder.LATEST_ADQUISITION_DATE;
